<div class="card">
  <div class="card-body">
    <div class="row bg-light py-3">
        <div class="col-6 d-flex align-items-center">
            <i class="fas fa-cog me-2"></i> General Setting
        </div>
        <div class="col-6 text-end">
            <button class="btn btn-primary" (click)="onsubmit()">Save</button>
        </div>
    </div>
    <div class="borderBottom"></div>
    <div class="row d-flex align-items-center p-2">
      <div class="col-3 ">Form Creation</div>
      <div class="col-3 mt-1">
        <label class="switch">
          <input id="formswitchInput" type="checkbox" [checked]="isFormChecked" />
          <span class="slider round"></span>
        </label>
      </div>
      <div class="col-3">
        <select class="form-select taskspanel" id="teams">
          <option value="0">NA</option>
       
        </select>
      </div>
    </div>
    <div class="borderBottom"></div>
    <div class="row d-flex align-items-center p-2">
        <div class="col-3 ">Auto Create</div>
        <div class="col-3 mt-1">
          <label class="switch">
            <input type="checkbox" id="autoSwitchInput"  [checked]="isAutoChecked" />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col-3">
          <select class="form-select taskspanel" id="teams">
            <option value="0">NA</option>
         
          </select>
        </div>
      </div>
    <div class="borderBottom"></div>
    <div class="row d-flex align-items-center p-2">
   <div class="col-3">Allow Create</div>
   <div class="col-3 mt-1">
     <label  class="switch">
       <input id="allowSwitchInput" type="checkbox"  [checked]="isAllowChecked" />
       <span class="slider round"></span>
     </label>
   </div>

</div>
    <div class="borderBottom"></div>
    <div class="row d-flex align-items-center p-2">
        <div class="col-3">Create Cut off</div>
        <div class="col-3">
            <select class="form-select taskspanel" id="teams">
              <option value="0">Daily</option>
           
            </select>
          </div>
    
    </div>
    <div class="borderBottom"></div>
    <div class="row d-flex align-items-center p-2">
        <div class="col-3">Allow Update</div>
        <div class="col-3">
            <select class="form-select taskspanel" id="teams">
              <option value="0">NA</option>
           
            </select>
          </div>
    </div>
    <div class="borderBottom"></div>
    <div class="row d-flex align-items-center p-2">
        <div class="col-3">Update Cut off</div>
        <div class="col-3 mt-1">
            <label class="switch">
              <input id="updateSwitchInput" type="checkbox"  [checked]="isUpdateChecked" />
              <span class="slider round"></span>
            </label>
          </div>
    
    </div>
    <div class="borderBottom"></div>
    <div class="row d-flex align-items-center p-2">
        <div class="col-3">Allow Cancellation</div>
        <div class="col-3 mt-1">
            <label class="switch">
              <input id="cancellationSwitchInput" type="checkbox"  [checked]="isCancellationChecked"/>
              <span class="slider round"></span>
            </label>
          </div>
    </div>
    <div class="borderBottom"></div>
    <div class="row d-flex align-items-center p-2">
        <div class="col-3">Cancellation cut off</div>
        <div class="col-3">
            <select class="form-select taskspanel" id="teams">
              <option value="0">NA</option>
           
            </select>
          </div></div>
    <div class="borderBottom"></div>
  </div>
</div>
